export default function jsStyleToString(style){
  const formattedStyle = Object.keys(style).map(key=>`${key}:${style[key]}`)
  return formattedStyle.join(';')
}